import React, { useEffect, useState } from 'react';
import { SettingsHeaderIcon } from 'components/common/icons';
import { Button, Checkbox, Col, Dropdown, Menu, Row, Typography } from 'components';
import styles from './styles.module.scss';
import './antd.scss';

const { Text } = Typography;

const columnsList = [
  { label: 'Item Number, SKU', value: 'sku' },
  { label: 'Item Description', value: 'description' },
  { label: 'Qty', value: 'quantity' },
  { label: 'Prch. Price Per Piece', value: 'purchasePricePerPiece' },
  { label: 'Discount', value: 'discount' },
  { label: 'Lead Time', value: 'leadTime' },
  { label: 'Shipping Cost', value: 'shippingCost' },
  { label: 'Copper Fee', value: 'copper' },
  { label: 'Fees', value: 'fees' },
  { label: 'Item Dimensions', value: 'dimensions' },
  { label: 'Weight', value: 'weight' },
  { label: 'Notes', value: 'notes' },
  { label: 'Attch.', value: 'attachments' },
];

type DisplayColumnsDropdownProps = {
  visibleColumns: string[];
  onVisibleColumnsChange: (keys: string[]) => void;
};

export const DisplayColumnsDropdown: React.FC<DisplayColumnsDropdownProps> = (props) => {
  const { visibleColumns, onVisibleColumnsChange } = props;
  const [selectedColumns, setSelectedColumns] = useState<string[]>(visibleColumns);
  const [allSelected, setAllSelected] = useState<boolean>();

  useEffect(() => {
    setAllSelected(visibleColumns.length === columnsList.length);
    setSelectedColumns(visibleColumns);
  }, [visibleColumns]);

  const handleToggle = (key: string) => {
    let keys: string[] = [];
    setSelectedColumns((prev) => {
      keys = prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key];
      return keys;
    });
    onVisibleColumnsChange(keys);
  };

  const menu = (
    <Menu
      items={[
        {
          className: 'column-dropdown-menu',
          key: 'select_all',
          label: (
            <Row
              align={'middle'}
              justify={'space-between'}
              className={styles.column_item}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedColumns(allSelected ? [] : columnsList.map((i) => i.value));
                onVisibleColumnsChange(allSelected ? [] : columnsList.map((i) => i.value));
              }}
            >
              <Col>
                <Text className={'font-size-16 font-weight-600'}>Display Columns</Text>
              </Col>
              <Col>
                <Row className={'gap-10'}>
                  <Text type={'secondary'}>Select All</Text>
                  <Checkbox checked={allSelected} />
                </Row>
              </Col>
            </Row>
          ),
        },
        ...columnsList.map((column) => ({
          className: 'column-dropdown-menu',
          key: column.value,
          label: (
            <Row
              align={'middle'}
              justify={'space-between'}
              className={styles.column_item}
              onClick={(e) => {
                e.stopPropagation(); // Prevent closing
                handleToggle(column.value);
              }}
            >
              <Text type={'secondary'}>{column.label}</Text>
              <Checkbox checked={selectedColumns.includes(column.value)} />
            </Row>
          ),
        })),
      ]}
    />
  );

  return (
    <Dropdown
      dropdownRender={() => <div style={{ width: 306 }}>{menu}</div>}
      trigger={['click']}
      placement="bottomLeft"
    >
      <Button icon={<SettingsHeaderIcon />} />
    </Dropdown>
  );
};
